import {
    GET_PRODUCT_TYPE_DEF_SUCCESS,
    PRODUCT_TYPE_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const productTypeDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_PRODUCT_TYPE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case PRODUCT_TYPE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default productTypeDef